import { Gradient } from '@/components/Icon'
import type { ColorName } from '@/components/Icon'

export function ShieldIcon({ id, color }: { id: string; color: ColorName }) {
  return (
    <>
      <defs>
        <Gradient
          id={`${id}-gradient`}
          color={color}
          gradientTransform="matrix(0 21 -21 0 20 3)"
        />
        <Gradient
          id={`${id}-gradient-dark`}
          color={color}
          gradientTransform="matrix(0 22.75 -22.75 0 16 6.25)"
        />
      </defs>

      <svg fill={`url(#${id}-gradient-dark)`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 7.164C5 7.053 5.074 6.957 5.179 6.929C8.856 6.01 12.119 3.746 13.822 2.65c0.31-0.199 0.701-0.199 1.011 0C16.538 3.746 19.8 6.01 23.477 6.929C23.583 6.957 23.657 7.053 23.657 7.164V15c0 4.47-2.056 7.574-4.148 9.571C17.44 26.545 15.4 27.484 14.36 27.883c-0.215 0.083-0.45 0.083-0.665 0C12.656 27.484 10.616 26.545 8.492 24.57C6.399 22.574 5 19.47 5 15V7.164z"
        />
        <path d="M14 18L20 12L18.59 10.59L14 15.17L11.41 12.59L10 14L14 18Z" />
        <path d="M5 7.164C5 7.053 5.074 6.957 5.179 6.929C8.856 6.01 12.119 3.746 13.822 2.65c0.31-0.199 0.701-0.199 1.011 0C16.538 3.746 19.8 6.01 23.477 6.929C23.583 6.957 23.657 7.053 23.657 7.164V15c0 4.47-2.056 7.574-4.148 9.571C17.44 26.545 15.4 27.484 14.36 27.883c-0.215 0.083-0.45 0.083-0.665 0C12.656 27.484 10.616 26.545 8.492 24.57C6.399 22.574 5 19.47 5 15V7.164zM7 8.615v6.385c0 3.53 1.606 5.874 3.308 7.559C11.938 24.175 13.587 24.972 14.328 25.27c0.072 0.028 0.15 0.028 0.222 0C15.292 24.972 16.94 24.175 18.57 22.56C20.273 20.874 21.879 18.53 21.879 15V8.615C18.928 7.869 16.19 6.056 14.329 4.844c-0.103-0.066-0.234-0.066-0.337 0C12.132 6.056 9.393 7.869 7 8.615z" />
      </svg>
    </>
  )
}
